import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import IconButton from "@mui/material/IconButton";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GET_ALL_PACS, GET_ALL_PACS_CONFIG } from "../../appConstants";
import "../../components/Headers/Header.css";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import DeleteAlert from "../DeleteAlert";
import HomeHeader from "../HomeHeader";
import AddRuleModal from "../Modal/AddRuleModal";
import "../Modal/Modal.css";
import SideBar from "../SideBar/SideBar";
import "../Tables/Table.css";
import LoaderComponent from "../ConfigurePages/LoaderComponent/LoaderComponent";

const ConfigDataTable = () => {
  const navigate = useNavigate();
  const [loader, setloader] = useState(true);
  const [data, setData] = useState();
  const [data2, setData2] = useState();
  const [count, setCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [add, setAdd] = useState(false);
  const [update, setUpdate] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [deleteID, setDeleteID] = useState(0);
  const [deleteUpdate, setdeleteUpdate] = useState(false);

  const FilterTableHeader = [
    "Config Name",
    "Receive From PACS",
    "Send To PACS",
  ];

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      fontSize: 15,
    },
  }));

  const handlePageChange = (page) => {
    if (page >= 0 && page <= totalPages) {
      setCount(page + 1);
    }
  };

  const handleModalClose = () => {
    setAdd(false);
  };

  const handleclick = () => {
    setEditData();
    setAdd(true);
  };

  const handleDelete = (id) => {
    setDeleteAlert(true);
    setDeleteID(id);
  };

  const handleEdit = (data) => {
    setAdd(true);
    setEditData(data);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloader(false);
        const response = await axiosInstance.post(
          `${GET_ALL_PACS_CONFIG}?page=${count}&size=10`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setData(response.data.items);
        setTotalPages(response.data.pages);
        setloader(true);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setloader(true);
      }
    };

    fetchData();
  }, [count, update, deleteUpdate]);

  useEffect(() => {
    const fetchData1 = async () => {
      try {
        const response = await axiosInstance.post(
          GET_ALL_PACS,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setData2(response.data.items);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };

    fetchData1();
  }, [count, update]);

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("authenticated");
    if (isAuthenticated !== "true") {
      navigate("/login");
    }
  });

  return (
    <div className="d-flex min-vh-100  background">
      <SideBar />
      <div>
        <HomeHeader />
        <div className="d-flex flex-column ">
          <div className="header">
            <div className="header-text d-flex justify-content-between">
              <div>PACS Configuration</div>
              <div>
                <button
                  type="button"
                  className="btn  mr-4 shadow  btn-dataset"
                  style={{
                    height: "39px",
                    width: "200px",
                    color: "black",
                    backgroundColor: "rgb(15, 196, 160)",
                    top: "28px",
                    fontWeight: "bold",
                    cursor: " pointer",
                    font: "Montserrat",
                  }}
                  onClick={handleclick}
                >
                  ADD
                </button>
              </div>
            </div>
          </div>

          {loader ? (
            <div>
              <table className="styled-table">
                <thead>
                  <tr>
                    {/* <th>SR.No.</th> */}
                    {data &&
                      FilterTableHeader.map((header) => <th>{header}</th>)}
                    <th>Actions</th>
                  </tr>
                </thead>
                {data && data.length > 0 ? (
                  <tbody>
                    {data &&
                      data.map((item, index) => (
                        <tr key={index}>
                          {/* <td>{index + 1 + (count - 1) * 10}</td> */}
                          <td>{item.pacs_config_name}</td>
                          <td>
                            <table
                              className="styled-table"
                              style={{ width: "100%", margin: 0 }}
                            >
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>AE Title</th>
                                  <th>Port</th>
                                  <th>IP</th>
                                </tr>
                              </thead>

                              <tbody>
                                {item.recieve_from_pacs.map((item2, index) => (
                                  <tr key={index} className="styled-table">
                                    <td>{item2.name}</td>
                                    <td>{item2.ae_title}</td>
                                    <td>{item2.port}</td>
                                    <td>{item2.ip}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </td>

                          <td>
                            <table
                              className="styled-table"
                              style={{ width: "100%", margin: 0 }}
                            >
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>AE Title</th>
                                  <th>Port</th>
                                  <th>IP</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.send_to_pacs.map((item3, index) => (
                                  <tr key={index} className="styled-table">
                                    <td>{item3.name}</td>
                                    <td>{item3.ae_title}</td>
                                    <td>{item3.port}</td>
                                    <td>{item3.ip}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </td>
                          <td>
                            <BootstrapTooltip title="Delete">
                              <IconButton>
                                <DeleteIcon
                                  onClick={() =>
                                    handleDelete(item.pacs_config_id)
                                  }
                                  style={{ color: "white", cursor: "pointer" }}
                                />
                              </IconButton>
                            </BootstrapTooltip>
                            {deleteAlert && (
                              <DeleteAlert
                                type="PacsConfigTable"
                                id={deleteID}
                                data={data}
                                count={count}
                                handlePage={handlePageChange}
                                deleteAlert={deleteAlert}
                                setDeleteAlert={setDeleteAlert}
                                setdeleteUpdate={setdeleteUpdate}
                              />
                            )}
                            &nbsp;
                            <BootstrapTooltip title="Edit">
                              <IconButton>
                                <ModeEditIcon
                                  onClick={() => handleEdit(item)}
                                  style={{ color: "white", cursor: "pointer" }}
                                />
                              </IconButton>
                            </BootstrapTooltip>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center font-weight-bold">
                      No Records Found
                    </td>
                  </tr>
                )}
              </table>
              {data && data.length > 0 ? (
                <div className="d-flex justify-content-end pb-5">
                  <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={totalPages && totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    forcePage={count && count - 1} //{entityList.number}
                    onPageChange={(e) => handlePageChange(e.selected)}
                    containerClassName="pagination"
                    subContainerClassName="pages pagination"
                    activeClassName="active"
                    previousLinkClassName="pagination-link"
                    nextLinkClassName="pagination-link"
                    breakLinkClassName="pagination-link"
                    pageLinkClassName="pagination-link"
                  />
                  {/* <KeyboardArrowLeftIcon
                  className="text-success bg-light rounded"
                  onClick={() => handlePage(count - 1)}
                />
                <div className="mx-2 text-light">
                  <h6>{`Showing ${count} of ${totalPages} pages`}</h6>
                </div>
                <KeyboardArrowRightIcon
                  className="text-success bg-light rounded"
                  onClick={() => handlePage(count + 1)}
                /> */}
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ margin: "10vw 48vw" }}
            >
              <div>
                <LoaderComponent />
              </div>
            </div>
          )}
          {add && (
            <AddRuleModal
              data={data2}
              handleClose={handleModalClose}
              ModalState={add}
              setUpdate={setUpdate}
              editData={editData}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfigDataTable;
